import { get, patch, post, put } from '@elementary/common-ui/utils/http';
import {
  CreateAlertRuleApi,
  FetchAlertRules,
  UpdateAlertRuleApi,
} from '../types';

export const fetchAlertRules = (envId: string): Promise<FetchAlertRules> =>
  get(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/routing-rules`,
  );

export const createAlertRoutingRule = (
  data: CreateAlertRuleApi,
  envId: string,
) =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/routing-rules`,
    data,
  );

export const updateAlertRoutingRule = (
  data: UpdateAlertRuleApi,
  envId: string,
  ruleId: string,
) =>
  put(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/routing-rules/${ruleId}`,
    data,
  );

export const deactivateRule = (ruleId: string, envId: string) =>
  patch(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/routing-rules/${ruleId}/deactivate`,
    {},
  );

export const activateRule = (ruleId: string, envId: string) =>
  patch(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/routing-rules/${ruleId}/activate`,
    {},
  );
